import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { FailedAttempts } from './components/FailedAttempts';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
import { SectionDivider } from './components/SectionDivider';
export function App() {
  return <div className="min-h-screen bg-dark text-cream font-sans selection:bg-gold selection:text-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <SectionDivider data-id="element-3" />
      <Problem data-id="element-4" />
      <FailedAttempts data-id="element-5" />
      <SectionDivider data-id="element-6" />
      <Mechanism data-id="element-7" />
      <WhatYouGet data-id="element-8" />
      <SectionDivider data-id="element-9" />
      <WhoIsFor data-id="element-10" />
      <HowItWorks data-id="element-11" />
      <SectionDivider data-id="element-12" />
      <Proof data-id="element-13" />
      <FAQ data-id="element-14" />
      <OfferBlock data-id="element-15" />
      <Footer data-id="element-16" />
    </div>;
}